import BaseModel from '../../base';

import constants from './constants';
import { REQUEST_STATUS } from '../constants';
import glossary, { REQUEST_STATUS_DATA } from './glossary';

export default class AssociationClub extends BaseModel {
  constructor(item = {}, url) {
    super(item, url);

    this.description = item.description;

    this.request_created_at = item.request_created_at;
    this.request_status = item.request_status || item.status || REQUEST_STATUS.new;

    this.active_members_count = item.active_members_count ?? 0;

    this.change_at = item.change_at;
    this.change_by_representative_office_id = item.change_by_representative_office_id;
    this.change_by_representative_office_name = item.change_by_representative_office_name;
  }

  get statusData() {
    const { request_status } = this;
    const data = REQUEST_STATUS_DATA[request_status];
    return {
      ...data,
      isNew: request_status === REQUEST_STATUS.new,
      isAccepted: request_status === REQUEST_STATUS.accepted,
      isRejected: request_status === REQUEST_STATUS.rejected,
    };
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }
}
